import { render, staticRenderFns } from "./SingleFormResponses.vue?vue&type=template&id=19a2cea4&scoped=true"
import script from "./SingleFormResponses.vue?vue&type=script&lang=js"
export * from "./SingleFormResponses.vue?vue&type=script&lang=js"
import style0 from "./SingleFormResponses.vue?vue&type=style&index=0&id=19a2cea4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a2cea4",
  null
  
)

export default component.exports